/**
 * Drizzle query builders + query keys for the module SPINE (F2-A).
 * Local-first consumption (course streams extended with course_module /
 * course_settings / resource). Writes go through the write-path (author/editor authz).
 */

import {
  and,
  asc,
  course_module,
  course_settings,
  eq,
  isNull,
  type PowerSyncDrizzleDB,
  resource,
} from "@space/powersync";

export const moduleQueryKeys = {
  all: ["academy-modules"] as const,
  byCourse: (courseId: string | undefined) => ["academy-modules", "course", courseId] as const,
  settings: (courseId: string | undefined) => ["academy-modules", "settings", courseId] as const,
  resources: (courseId: string | undefined) => ["academy-modules", "resources", courseId] as const,
};

/** A course's (spine) modules, ordered by unit and position. */
export function getCourseModulesQuery(db: PowerSyncDrizzleDB, courseId: string) {
  return db
    .select()
    .from(course_module)
    .where(and(eq(course_module.course_id, courseId), isNull(course_module.deleted_at)))
    .orderBy(asc(course_module.position), asc(course_module.created_at));
}

/** A course's settings (singleton). id = course_id. */
export function getCourseSettingsQuery(db: PowerSyncDrizzleDB, courseId: string) {
  return db.select().from(course_settings).where(eq(course_settings.id, courseId)).limit(1);
}

/** A course's active resources. */
export function getCourseResourcesQuery(db: PowerSyncDrizzleDB, courseId: string) {
  return db
    .select()
    .from(resource)
    .where(and(eq(resource.course_id, courseId), isNull(resource.deleted_at)))
    .orderBy(asc(resource.created_at));
}
